import React from "react";
import { faStar, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Style from "./AllCommentsHeader.module.css";
import { useHistory } from "react-router";
const AllCommentsHeader = (props) => {

  let history = useHistory();

  return (
    <div className={Style.HeaderHolder}>
      <div className={Style.coverHolder}>
        <img  src={`https://cdn.barest.ir/supplier/cover/${props.shopDetail.cover}.jpg`} alt="فروشنده" />
      </div>
     <div onClick={() => history.goBack()} className={Style.Back}>
        <FontAwesomeIcon  icon={faArrowRight} className={Style.backIcon}/>
      </div>
     <div className={Style.LogoRate}>
       <div className={Style.logoHolder}><img  src={`https://cdn.barest.ir/supplier/logo/${props.shopDetail.logo}.jpg`} alt="لوگو فروشنده" /></div>
       <div className={Style.StoreRate}>
            <div className={Style.FixRate}>
              <div className={Style.RateHolder}>
                <div className={Style.grayStar}>
                  <FontAwesomeIcon icon={faStar} />
                  <FontAwesomeIcon icon={faStar} />
                  <FontAwesomeIcon icon={faStar} />
                  <FontAwesomeIcon icon={faStar} />
                  <FontAwesomeIcon icon={faStar} />
                </div>
                <div className={Style.GoldStar} style={{ width: `${props.shopDetail.supplier_rate*20}%` }}>
                  <div className={Style.GoldStarHolder}>
                    <FontAwesomeIcon icon={faStar} />
                    <FontAwesomeIcon icon={faStar} />
                    <FontAwesomeIcon icon={faStar} />
                    <FontAwesomeIcon icon={faStar} />
                    <FontAwesomeIcon icon={faStar} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          
       </div>
    </div>
  );
};

export default AllCommentsHeader;
